import { render, staticRenderFns } from "./page2Point.vue?vue&type=template&id=52579c77&scoped=true"
import script from "./page2Point.vue?vue&type=script&lang=js"
export * from "./page2Point.vue?vue&type=script&lang=js"
import style0 from "./page2Point.vue?vue&type=style&index=0&id=52579c77&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52579c77",
  null
  
)

export default component.exports